export const textFieldConf = [
    {
        xl: 1,
        lg: 1,
        md: 1,
        sm: 4,
        xs: 3,
        name: 'INT',
    },
    {
        xl: 2,
        lg: 2,
        md: 2,
        sm: 4,
        xs: 3,
        name: 'NAME',
    },
    {
        xl: 1,
        lg: 1,
        md: 1,
        sm: 4,
        xs: 3,
        name: 'MONTH',
    },
    {
        xl: 1,
        lg: 1,
        md: 1,
        sm: 4,
        xs: 3,
        name: 'YEAR',
    },
];
